<div class="d-flex align-items-center justify-content-between">
  <div *ngIf="isLargeTitle && !hiddenTitle" class="section-large-title">
    {{ titleSection }}
  </div>
  <div *ngIf="!isLargeTitle && !hiddenTitle" class="section-small-title">
    {{ titleSection }}
  </div>
  <div class="d-flex align-items-center border-primary">
    <p-toggle
      *ngIf="isActivable"
      title="Inclure le bloc dans le rapport"
      class="me-3"
      [checked]="isActivated"
      onLabel="Inclus"
      offLabel="Exclu"
      (switched)="onEnabledSectionSwitched($event)"
      [disabled]="isInputDisabled"
    ></p-toggle>

    <i-feather
      *ngIf="!onlyTitle && isEditable"
      name="edit"
      title="Editer"
      class="text-secondary pointer"
      (click)="openEditPanel()"
    ></i-feather>
  </div>
</div>

<div
  *ngIf="!onlyTitle"
  class="shadow-sm p-3 mb-5 bg-body rounded bg-white mt-1"
>
  <ng-content select="[read-mode]"></ng-content>
</div>

<p-modal
  *ngIf="isModalEditVisible"
  @modalAnimation
  [modalId]="modalId"
  [title]="titleSection"
  [canClose]="isCancable"
>
  <div>
    <div *ngIf="error.isError" class="alert alert-danger" role="alert">
      <strong>Erreur ! </strong>
      <!-- Fixme : Le mapping des vraie erreurs se fera plus tard, pour l'instant on affiche une erreur générique si pas de 
       message particulier à montrer, dans le cas contraire utiliser la propriété custom
      -->
      <!-- <span>{{ error.message }}</span> -->
      <span *ngIf="!error.custom">
        Veuillez vérifier votre saisie et réessayer. Si l'erreur persiste,
        veuillez contacter notre service client pour assistance.
      </span>
      <span *ngIf="error.custom">
        {{ error.message }}
      </span>
    </div>
    <div>
      <ng-content select="[edit-mode]"></ng-content>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <div class="col-2">
        <ng-content select="[save-button]"></ng-content>
      </div>
      <div class="col-2">
        <p-button
          id="btn-annuler-section"
          label="Annuler"
          title="Annuler"
          level="secondary"
          type="button"
          [disabled]="!isCancable"
          [width]="100"
          (click)="closeEditPanel()"
        ></p-button>
      </div>
    </div>
  </div>
</p-modal>
